import { Corn } from '@eigtech/shared-corn'
import { useQueryClient } from '@eigtech/ui-shared-api'
import { MeetingManager } from 'amazon-chime-sdk-component-library-react'
import { useCallback } from 'react'
import { getMeetingQueryOptions } from '../api/getMeeting'

export type UseGetAttendeeProps = {
  meetingId: string
  startTime: string
  entityId: Corn
}

export function useGetAttendee({ entityId, meetingId, startTime }: UseGetAttendeeProps) {
  const queryClient = useQueryClient()

  const getAttendee: Required<MeetingManager>['getAttendee'] = useCallback(
    async (attendeeId, userId) => {
      if (!userId) return { name: 'Anonymous' }

      if (!(meetingId && startTime)) {
        return { name: userId }
      }

      const meeting = await queryClient.fetchQuery(
        getMeetingQueryOptions({
          entityId,
          meetingId,
          startTime,
        })
      )

      const participant = meeting.participants.find(
        (participant) => participant.attendeeId === attendeeId
      )

      return { name: participant?.name ?? userId }
    },
    [entityId, meetingId, queryClient, startTime]
  )

  return getAttendee
}
